export default "__VITE_ASSET__tcreCwsj__$_?component__"